function addCharacterText() {
    document.querySelectorAll('.po-textField-characterCount').forEach(el => {
        if (!el.querySelector('.character-count-text')) {
            const span = document.createElement('span');
            span.className = 'character-count-text';
            span.textContent = ' Characters Used';
            el.appendChild(span);
        }
    });
}

addCharacterText();

const observer = new MutationObserver(addCharacterText);

observer.observe(document.body, {
    childList: true,
    subtree: true
});

function syncVariant() {
    const currentVariant = document.querySelector('.variant-option__button-label input:checked')?.value;

    if (!currentVariant) return;

    document.querySelectorAll('.po-radioGroup-item').forEach(item => {
        const label = item.querySelector('.po-optionItemLabel-label')?.textContent.trim();
        const input = item.querySelector('input[type="checkbox"]');

        if (!input) return;

        if (label === currentVariant && !input.checked) {
            input.click();
        }
    });
}

syncVariant();

new MutationObserver(syncVariant).observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener('change', e => {
    if (e.target.matches('.variant-option__button-label input[type="radio"]')) {
        setTimeout(syncVariant, 0);
    }
});